import axios from 'axios';
import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null,
      showDetails: false,
      errorLocation: null
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Проверяем, запущено ли приложение на localhost
    const isLocalhost = window.location.hostname === 'localhost'
      || window.location.hostname === '127.0.0.1'
      || window.location.hostname === '::1';

    if (isLocalhost) {
      console.error('Ошибка в локальной среде:', error, errorInfo);
      return; // Прерываем выполнение для localhost
    }
    // Парсим стек для получения информации о месте ошибки
    const stackLines = errorInfo.componentStack.split('\n');
    let errorLocation = 'unknown location';

    if (stackLines.length > 1) {
      const relevantLine = stackLines[1].trim();
      errorLocation = relevantLine
        .replace('at ', '')
        .replace(' (', ':')
        .replace(')', '').split(':')[0];
    }

    this.setState({
      errorInfo,
      errorLocation
    });





    const formData = new FormData();
    formData.append('context', errorLocation);
    formData.append('report', error.message);
    formData.append('date', Date.now().toString().replace('T', ' ').slice(0, 19))



    axios(
      {
        url: "report/insert",
        method: "POST",
        data: formData,

      })
      .then(response => response.data)

  }

  handleReset = () => {
    this.setState({
      hasError: false,
      error: null,
      errorInfo: null,
      showDetails: false,
      errorLocation: null
    });
    window.location.reload()

  };

  toggleDetails = () => {
    this.setState(prev => ({ showDetails: !prev.showDetails }));
  };

  renderErrorDetails() {
    const { error, errorLocation } = this.state;

    return (
      <div style={{
        marginTop: '20px',
        padding: '15px',
        backgroundColor: '#f5f5f5',
        borderRadius: '4px',
        fontFamily: 'monospace',
        fontSize: '14px',
        textAlign: 'left',
        maxWidth: '80%'
      }}>
        <div style={{ marginBottom: '10px', color: '#dc3545' }}>
          <strong>{error?.toString()}</strong>
        </div>
        <div style={{ color: '#6c757d' }}>
          {errorLocation}
        </div>
      </div>
    );
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          padding: '20px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
          backgroundColor: '#f8f9fa',
          color: '#dc3545',
          textAlign: 'center'
        }}>
          <img
            src="/main_logo.png"
            style={{
              minWidth: '300px',
              height: '65px',
              marginBottom: '20px'
            }}
            title="Служба поддержки продаж"
            alt="Logo"
          />

          <h1>Произошла критическая ошибка</h1>
          <p style={{ fontSize: '1.2rem' }}>
            Команда СПП уже знает о проблеме
          </p>

          <div style={{ margin: '30px 0' }}>
            <button
              onClick={this.toggleDetails}
              style={{
                padding: '10px 20px',
                margin: '0 10px',
                backgroundColor: '#6c757d',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer'
              }}
            >
              {this.state.showDetails ? 'Скрыть технические детали' : 'Показать технические детали'}
            </button>

            <button
              onClick={this.handleReset}
              style={{
                padding: '10px 20px',
                margin: '0 10px',
                backgroundColor: '#28a745',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer'
              }}
            >
              Перезагрузить страницу
            </button>
          </div>
          {this.state.showDetails && this.renderErrorDetails()}

        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;